import { buttonVariant } from '@sds-system/constants';
import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledIconButtonProps } from './IconButton.types';

export const StyledIconButton = styled('button')<StyledIconButtonProps>(
  ({ isRound, size, theme }) => {
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: theme.size[size],
      minWidth: theme.size[size],
      height: theme.size[size],
      minHeight: theme.size[size],
      padding: `0 !important`,
      margin: 0,
      borderRadius: `${isRound ? `${theme.borderRadius[999]}px !important` : '8px'}`,
      cursor: 'pointer',

      ':disabled': {
        cursor: 'not-allowed',
      },
    };
  },
  ({ theme }) => ({
    variants: [
      {
        props: { variant: 'solid.primary' },
        style: buttonVariant(theme)['solid.primary'],
      },
      {
        props: { variant: 'outline.primary' },
        style: buttonVariant(theme)['outline.primary'],
      },
      {
        props: { variant: 'outline.assistive' },
        style: buttonVariant(theme)['outline.assistive'],
      },
      {
        props: { variant: 'ghost.primary' },
        style: buttonVariant(theme)['ghost.primary'],
      },
      {
        props: { variant: 'ghost.assistive' },
        style: buttonVariant(theme)['ghost.assistive'],
      },
    ],
  }),
  getAllStyledProps,
);
